import {getMoveAnimation} from "./move"

export function getFadeAnimation (element, settings, animationcalculation) {
    //Fade only needs a opacity property for animations
    const fade = {
        opacity: 0
    };

    //Add move data to fade data if there's a startposition
    if( settings.start_position ) {
        let move = getMoveAnimation(element, settings, animationcalculation);
        for (let key in move) {
            fade[key] = move[key];
        }
    }
    return fade;
}

